import {
  CREATE_JURISDICTION_REQUEST,
  CREATE_JURISDICTION_SUCCESS,
  CREATE_JURISDICTION_FAILED,
} from './actionTypes';

const initialState = {
  jurisdiction: null,
  loading: false,
  error: null,
};

const jurisdictionCreateReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case CREATE_JURISDICTION_REQUEST:
      return { ...state, loading: true };
    case CREATE_JURISDICTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_JURISDICTION_FAILED:
      return {
        ...state, loading: false, error,
      };
    default:
      return state;
  }
};

export default jurisdictionCreateReducer;
